module.exports = __webpack_public_path__ + "img/V-L-1-unload-standup-shadow.0fb945fc.png";